import './PropertyInformation.scss';
import Component from './PropertyInformation.js';
export default Component;
